import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'

import { remind as remindPassword } from 'modules/users/passwords'
import ValidationErrors from '../../validation_errors'
import Group from '../../group'
import Submit from '../../submit'
import errorsSelector from 'selectors/errors'

const getEditPasswordUriBase = ({ protocol, host }) => `${protocol}//${host}/users/password/edit`

const RemindPasswordForm = ({ submitting, handleSubmit, config_parameters, errors }) => (
  <form onSubmit={handleSubmit}>
    <br />
    <ValidationErrors errors={errors} />
    <Grid container direction="column">
      <Grid item>
        <Field
          name="email"
          type="email"
          component={Group}
          label={I18n.t('users.common.email')}
          required
        />
      </Grid>
      <Grid item>
        <br />
        <Submit value={I18n.t('users.password.remind.submit')} />
      </Grid>
    </Grid>
  </form>
)

const mapStateToProps = state => ({
  errors: errorsSelector('users.passwords', 'validation_error')(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ remindPassword }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'remind_password',
    onSubmit: (props, dispatch, { remindPassword }) =>
      remindPassword({ ...props, edit_password_uri: getEditPasswordUriBase(window.location) })
  })(RemindPasswordForm)
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/password/new/form.js